<template>
  <div class="person">
    <div class="titleWrap">
      <div class="setTitle">人员管理</div>
      <el-button class="myBtn" type="primary" size="small" v-if="funcData.indexOf('add') > -1" @click="add">新增</el-button>
      <div class="clearfix"></div>
    </div>
    <el-main class="tableWrap">
      <el-input class="input" v-model.trim="personName" size="small" placeholder="人员名称"></el-input>
      <el-select class="select" v-model="role" filterable clearable size="small" placeholder="角色">
        <el-option v-for="item in roleList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-button class="searchBtn" type="primary" size="small" @click="search"><i class="el-icon-search"></i></el-button>
      <div class="clearfix"></div>
      <el-table :data="personAttr" class="list">
        <el-table-column type="index" label="序号" width="80" :index="indexMethod" :align="align"></el-table-column>
        <el-table-column prop="name" label="人员名称" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="phone" label="联系方式" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="roleName" label="角色名" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="state" label="状态" min-width="180" :align="align">
          <template slot-scope="scope">
            <div class="state open" v-if="scope.row.state === 'Y'"></div>
            <span v-if="scope.row.state === 'Y'">启用</span>
            <div class="state close" v-if="scope.row.state === 'N'"></div>
            <span v-if="scope.row.state === 'N'">禁用</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" min-width="150" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="funcData.indexOf('edit') > -1" @click="edit(scope.row.id)">编辑</el-button>
            <el-button type="text" size="small" v-if="funcData.indexOf('resetPassword') > -1" @click="initPassword(scope.row.id)">初始化密码</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page.sync="personCurr" :page-sizes="[10, 20, 50]" :page-size="personSize" :total="personTotal" @current-change="personCurrChange" @size-change="personSizeChange"></el-pagination>
    </el-main>
    <!-- 新增编辑人员弹出层 -->
    <el-dialog :visible.sync="dialog" :title="title" width="500px" :close-on-click-modal="false" @close="notBtn">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
        <el-form-item label="用户名" prop="username">
          <el-input v-model.trim="form.username" :disabled="isEdit" placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" v-if="!isEdit">
          <el-input v-model.trim="form.password" :disabled="true" placeholder="密码"></el-input>
        </el-form-item>
        <el-form-item label="人员名称" prop="personName">
          <el-input v-model.trim="form.personName" placeholder="人员名称"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="phone">
          <el-input v-model.trim="form.phone" placeholder="联系方式" :maxLength="11"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="role">
          <el-select class="select" v-model="form.role" filterable clearable size="small" placeholder="角色">
            <el-option v-for="item in form.roleList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="人员状态" :required="true">
          <el-switch v-model="form.personStatus" active-text="启用" inactive-text="停用"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="notBtn">取 消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="okBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Person',
  data () {
    return {
      align: this.$align, // 表格对齐方式
      villageId: '', // 小区Id
      villageName: '', // 小区名称
      villageValue: '', // 小区名称下拉菜单选中value
      villageList: [], // 小区名称下拉菜单
      personName: '', // 人员名称查询输入框
      role: '', // 角色下拉菜单选中value
      roleList: [], // 角色下拉菜单
      personAttr: [], // 人员列表
      personTotal: 0, // 人员总数
      personSize: 10, // 人员每页条数
      personCurr: 1, // 人员当前页数
      dialog: false, // 人员弹出层状态
      title: '', // 人员弹出层标题
      loading: false, // 人员弹出层确定按钮loading
      isEdit: false, // 是否为编辑
      form: {
        id: '', // 人员Id
        villageId: '', // 小区Id
        username: '', // 用户名
        password: '', // 密码
        personName: '', // 人员名称
        phone: '', // 联系方式
        role: '', // 角色
        roleList: [], // 角色下拉框
        personStatus: true // 人员状态
      },
      rules: {
        username: [
          {
            required: true,
            message: '请输入用户名',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z\u4e00-\u9fa5]+$/
              if (!reg.test(value)) {
                callback(new Error('用户名由中英文字符及数字组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z_]+$/
              if (!reg.test(value)) {
                callback(new Error('密码由英文字符、数字及下划线组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        personName: [
          {
            required: true,
            message: '请输入人员名称',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z\u4e00-\u9fa5]+$/
              if (!reg.test(value)) {
                callback(new Error('人员名称由中英文字符及数字组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        phone: [
          {
            required: true,
            message: '请输入联系方式',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^1[3456789]\d{9}$/
              if (!reg.test(value)) {
                callback(new Error('请输入正确的联系方式'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        role: [
          {
            required: true,
            message: '请选择角色',
            trigger: 'change'
          }
        ]
      }
    }
  },
  computed: {
    // 功能权限
    funcData () {
      let data = this.$store.state.menus.funcData
      let buttonArr = []
      for (let i = 0; i < data.length; i++) {
        if (data[i].url === this.$store.state.menus.activeMenu) {
          buttonArr.push(data[i].funcBotton)
        }
      }
      return JSON.parse(JSON.stringify(buttonArr))
    }
  },
  mounted () {
    // 小区名称
    if (this.$store.state.user.villageId === '') {
      this.villageId = ''
      this.villageName = ''
    } else {
      this.villageId = this.$store.state.user.villageId
      this.villageName = this.$store.state.user.villageName
    }

    // 获取角色下拉菜单
    this.$http.get(this.$api.role_select, {
      params: {
        orgId: this.villageId
      }
    }).then((res) => {
      let data = res.data

      if (data.success) {
        this.roleList = data.data.data
        this.form.roleList = data.data.data
      } else {
        this.$message({
          type: 'error',
          message: data.msg,
          duration: 1000
        })
      }
    }).catch((err) => {
      console.log(err)
    })
    // 获取权限列表
    this.getPersonList(this.personCurr, this.personSize)
  },
  methods: {
    getPersonList (page, size) {
      this.$http.get(this.$api.admin_list, {
        params: {
          pageNum: page,
          pageSize: size,
          orgId: this.villageId,
          name: this.personName,
          roleId: this.role
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.personAttr = data.data.list
          this.personTotal = data.data.total
          this.personSize = size
          this.personCurr = page
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    search () {
      this.getPersonList(1, this.personSize)
    },
    add () {
      if (this.$store.state.user.villageId === '') {
        this.form.villageId = ''
      } else {
        this.form.villageId = this.$store.state.user.villageId
      }
      this.isEdit = false
      this.dialog = true
      this.title = '新增人员'
      this.form.password = 'cfbe7424fq0'
    },
    edit (id) {
      this.$http.get(this.$api.admin_detail, {
        params: {
          id: id
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.form.id = id
          this.form.villageId = data.data.orgId
          this.form.username = data.data.account
          this.form.personName = data.data.name
          this.form.phone = data.data.phone
          this.form.role = data.data.roleId
          if (data.data.state === 'N') {
            this.form.personStatus = false
          }
          if (data.data.state === 'Y') {
            this.form.personStatus = true
          }
          this.isEdit = true
          this.dialog = true
          this.title = '编辑人员'
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    initPassword (id) {
      this.$confirm('是否初始化密码为cfbe7424fq0?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let formData = new FormData()
        formData.append('id', id)
        formData.append('newPassword', 'cfbe7424fq0')

        this.$http({
          method: 'post',
          url: this.$api.reset_password,
          data: formData
        }).then((res) => {
          let data = res.data

          if (data.success) {
            this.$message({
              message: '密码已初始化为cfbe7424fq0',
              type: 'success',
              duration: 1000
            })
            this.getPersonList(this.personCurr, this.personSize)
          } else {
            this.$message({
              type: 'error',
              message: data.msg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {})
    },
    notBtn () {
      this.$refs.form.resetFields()
      this.form.id = ''
      this.form.villageId = ''
      this.form.username = ''
      this.form.password = ''
      this.form.personName = ''
      this.form.phone = ''
      this.form.role = ''
      this.form.personStatus = true
      this.loading = false
      this.dialog = false
    },
    okBtn () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          let formData = new FormData()
          formData.append('id', this.form.id)
          formData.append('orgId', this.villageId)
          formData.append('account', this.form.username)
          formData.append('password', this.form.password)
          formData.append('name', this.form.personName)
          formData.append('phone', this.form.phone)
          formData.append('roleId', this.form.role)
          if (this.form.personStatus) {
            formData.append('state', 'Y')
          } else {
            formData.append('state', 'N')
          }

          if (this.form.id === '') {
            this.$http({
              method: 'post',
              url: this.$api.admin_add,
              data: formData
            }).then((res) => {
              let data = res.data

              if (data.success) {
                this.$message({
                  message: '新增人员成功',
                  type: 'success',
                  duration: 1000
                })
                this.notBtn()
                this.getPersonList(this.personCurr, this.personSize)
              } else {
                this.$message({
                  type: 'error',
                  message: data.msg,
                  duration: 1000
                })
                this.loading = false
              }
            }).catch((err) => {
              console.log(err)
              this.loading = false
            })
          } else {
            this.$http({
              method: 'post',
              url: this.$api.admin_edit,
              data: formData
            }).then((res) => {
              let data = res.data

              if (data.success) {
                this.$message({
                  message: '编辑人员成功',
                  type: 'success',
                  duration: 1000
                })
                this.notBtn()
                this.getPersonList(this.personCurr, this.personSize)
              } else {
                this.$message({
                  type: 'error',
                  message: data.msg,
                  duration: 1000
                })
                this.loading = false
              }
            }).catch((err) => {
              console.log(err)
              this.loading = false
            })
          }
        } else {
          return false
        }
      })
    },
    personCurrChange (curr) {
      this.getPersonList(curr, this.personSize)
    },
    personSizeChange (size) {
      this.getPersonList(this.personCurr, size)
    },
    notData (str) {
      return this.$null(str)
    },
    operateTime (time) {
      if (time === '' || time === null) {
        return '-'
      } else {
        return time.substr(0, 4) + '-' + time.substr(5, 2) + '-' + time.substr(8, 2) + ' ' + time.substr(11, 2) + ':' + time.substr(14, 2) + ':' + time.substr(17, 2)
      }
    },
    indexMethod (index) {
      // index从0开始
      return index + 1 + (this.personCurr - 1) * this.personSize
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.person
  box-sizing border-box
  padding 80px 20px 60px
  width 100%
  height 100%
  background-color #F5F7FA
  .titleWrap
    width 100%
    height 32px
    .setTitle
      float left
      height 32px
      line-height 32px
      font-weight bold
      font-size 18px
      color #333
    .myBtn
      float right
  .tableWrap
    margin-top 20px
    padding-left 0px
    padding-right 0px
    background-color #fff
    border-radius 4px
    box-shadow 0 3px 5px 0 rgba(0, 0, 0, .05)
    .select
      float left
      margin-left 20px
      width 160px
    .input
      float left
      margin-left 20px
      width 160px
    .time
      float left
      margin-left 20px
    .searchBtn
      float left
      margin-left 20px
      padding 5.5px 6px
      font-size 18px
    .list
      margin-top 20px
      &>>>thead
        tr, th
          color #666
          background-color #fafafa
          .cell
              font-weight bold
      &>>>tbody
        tr, th
          color #333
      &>>>td
        padding 7px 0
      .cell
        line-height 26px
        .state
          display inline-block
          width 10px
          height 10px
          border-radius 50%
          &.open
            background-color #60ACFC
          &.close
            background-color #ccc
    .el-pagination
      margin-top 20px
      padding 0 20px 0
      text-align right
  &>>>.el-dialog
    .el-dialog__header
      border-bottom 1px solid #eee
    .el-dialog__body
      max-height 300px
      overflow auto
      .el-form
        width 350px
        .el-select
          width 100%
</style>



// WEBPACK FOOTER //
// src/components/system/person.vue